import { TABLE_NAMES } from "@constants";

const { CLIENT, USER } = TABLE_NAMES;

/**
 * Generic function to combine team members with customer details
 * @param {Array} teamMembers - Array of team members
 * @param {Object} customerDetails - Customer details
 * @returns {Array} Combined array with the main client at the beginning
 */
export const teamMembersWithClient = (teamMembers = [], customerDetails) => {
  const membersArray = teamMembers?.map((member) => ({
    ...member,
    userId: Number(member.userId),
    tableName: USER,
  }));

  const documentSigner = membersArray?.find((member) => member.documentSigner);

  if (customerDetails) {
    const clientId = customerDetails.client_id || customerDetails.id;
    const mainClient = {
      id: `client-${clientId}`,
      clientId: Number(clientId),
      userId: Number(clientId),
      name: `${customerDetails.name || ""} ${customerDetails.child_last_name || ""}`.trim(),
      firstName: customerDetails.name || "",
      lastName: customerDetails.child_last_name || "",
      email: documentSigner?.email || "", // take the email from the document signer
      phone: documentSigner?.phone || "", // take the phone from the document signer
      phoneNumber: documentSigner?.phone || "", // take the phone number from the document signer
      dateOfBirth: customerDetails.dob || null,
      gender: customerDetails.gender || "",
      relationship: "self",
      relationshipToClient: "self",
      country:
        customerDetails.country && customerDetails.country !== "" ? customerDetails.country : "US",
      state: customerDetails.state || "",
      city: customerDetails.city || "",
      zip: customerDetails.zip || "",
      address: customerDetails.line1 || "",
      address1: customerDetails.line1 || "",
      address2: customerDetails.line2 || "",
      hasAcceptedInvite: true,
      isMainClient: true,
      tableName: CLIENT,
    };

    membersArray?.unshift(mainClient);
  }

  return membersArray;
};
